import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
  name: "utcDate",
})
export class UtcDatePipe implements PipeTransform {
  /**
   * Takes a datetime and formats it
   */
  transform(value: Date, ...args) {
    if (value === null || value === undefined) {
      return "";
    }

    return moment.utc(value).format("MM/DD/YYYY");
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/utc-date.pipe.ts